import updateEditorMode from './updateEditorMode';
import EditorOverlayStateEnum from '../EditorOverlayConstants';

export const setEditorMode = (mode, persist = true) =>
  updateEditorMode(mode, persist);
export const enableSign = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.SIGN, persist);
export const enableEdit = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.EDIT, persist);
export const enableView = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.VIEW, persist);
export const enableRequestSignature = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.REQUEST_SIGNATURE, persist);
export const enableRequestSignatureWait = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.REQUEST_SIGNATURE_WAIT, persist);
// The request-fill state should never be written to the database.
export const enableRequestSignatureFill = () =>
  updateEditorMode(EditorOverlayStateEnum.REQUEST_SIGNATURE_FILL, false);
export const enableSenderSigning = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.SENDER_SIGNING, persist);
export const enableLocked = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.LOCKED, persist);
export const enableComposeSigners = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.COMPOSE_REQUEST_SIGNERS, persist);
export const enableComposeFields = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.COMPOSE_REQUEST_FIELDS, persist);
export const enableComposeMessage = (persist = true) =>
  updateEditorMode(EditorOverlayStateEnum.COMPOSE_REQUEST_MESSAGE, persist);



// WEBPACK FOOTER //
// ./src-react/EditorOverlay/EditorOverlayActions/updateAliases.jsx